import challengeFields from "../inputsConfig";

const { questionnaire: questionnaireFields } = challengeFields;
export default {
  accordion: true,
  items: {
    "Rewards & Challenge Details": [
      {
        name: "Reward Policy",
        required: true,
        description:
          "Select how rewards will be distributed to participants based on their performance",
        fields: questionnaireFields.reward_policy,
      },
      {
        name: "Total rewards",
        required: true,
        description: "Enter the total reward amount",
        fields: questionnaireFields.reward_points,
      },
      {
        name: "Deadline",
        required: true,
        fields: questionnaireFields.deadline,
      },
      {
        name: "Challenge image",
        required: true,
        description:
          "Upload the image you would like to represent this challenge. If you'd prefer to use a video, skip this question and process to the next one.",
        fields: questionnaireFields.snapshot_pic,
      },
      {
        name: "Should solver attach any file?",
        required: false,
        fields: [
          questionnaireFields[
            "contest_layout_customization.attach_file_to_submission"
          ],
          questionnaireFields[
            "contest_layout_customization.attach_file_to_submission_label"
          ],
        ],
      },
      {
        name: "Link to video",
        required: false,
        description:
          "Enter youtube video link here to replace the challenge image with a video. Optional",
        fields: questionnaireFields.link_to_video,
      },
      {
        name: "Challenge title",
        required: true,
        description: "Provide a title for this challenge.",
        fields: questionnaireFields.title,
      },
      {
        name: "Challenge description",
        required: true,
        description:
          "Provide a brief description of the challenge and its purpose. Drag and drop images. Copy + Paste image/video URLs and they will be automatically embedded.",
        fields: questionnaireFields.description,
      },
      {
        name: "Prize description",
        required: true,
        description: "Provide a brief description of the prizes to be awarded.",
        fields: questionnaireFields.short_description,
      },
      {
        name: "Evaluation Scheme",
        description:
          "Personalize how challengers evaluate submissions on their dashboard. This cannot be changed once the challenge is launched!",
        required: false,
        fields: [
          questionnaireFields["contest_evaluation_scheme.evaluation_rubric"],
          questionnaireFields[
            "contest_evaluation_scheme.pairwise_rating_scheme"
          ],
        ],
      },
      {
        name: "Feedback tags",
        description:
          "Tags that will be shown to the solver when they submit a solution. These tags will be used to rate the solution.",
        required: false,
        fields: questionnaireFields.feedback_tags,
      },
    ],
    "Supplementals, Add-ons, Targeting": [
      {
        name: "Supplemental Submission Fields",
        required: false,
        fields: questionnaireFields.supplemental_submission_fields,
      },
      {
        name: "Include AI Submission",
        description:
          "Select yes for an AI-generated submission to be added to the challenge dashboard",
        required: false,
        fields: questionnaireFields.generate_ai_solution,
      },
      {
        name: "Contest Visibility",
        description:
          "Choose if the challenge must be visible to everybody or just logged in users.",
        required: false,
        fields: questionnaireFields.privacy_type,
      },
      {
        name: "Target Problem Solvers",
        description:
          "Problem solvers in the selected tier will be able to access the challenge.",
        required: false,
        fields: questionnaireFields["target_problem_solvers.criteria"],
      },
      {
        name: "Target Problem Solver Criteria",
        description:
          "Problem solvers that meet any of the above criteria will be able to access the challenge.",
        required: false,
        fields: questionnaireFields.contest_permissions,
      },
      {
        name: "Strict Problem Solver Criteria",
        description:
          "By selecting 'Yes', top-tier solvers will not bypass location restriction testing for access to challenge.",
        required: false,
        fields: questionnaireFields.strict_contest_permissions,
      },
    ],
    "Restrictions & Control": [
      {
        name: "Auto-approve Solutions",
        description:
          "By selecting 'Yes', all solutions will be automatically approved and visible to clients without the need for MindSumo admin approval",
        required: true,
        fields: questionnaireFields.auto_approve_submissions,
      },
      {
        name: "First-time Solution Restrictions",
        description:
          "By selecting “yes” first-time and unrated solvers will not be able to upload attachments or paste content when creating a submission. Submissions also need to be at least 200 characters long.",
        required: true,
        fields: questionnaireFields.restricted_for_1st_time_solver,
      },
      {
        name: "Uses MindSumo Community",
        description:
          "When a challenge doesn't use MindSumo community (e.g. employee challenges), we change some parts of the experience such as not displaying ratings to participants.",
        required: true,
        fields: questionnaireFields.no_community_contest,
      },
      {
        name: "Anonymous Challenge",
        description:
          "When challenges are anonymous, masks identifying information about the company. Problem solvers view visible companies more highly, so standard is preferred.",
        required: true,
        fields: questionnaireFields.anonymous,
      },
      {
        name: "Require Registered Problem Solvers",
        description:
          "When required, a user must sign in/register as a problem solver in order to solve.",
        required: false,
        fields: questionnaireFields.require_user_login,
      },
      {
        name: "Submissions per Problem Solver",
        description:
          "Allows problem solvers to submit multiple times. They can only work on one submission at a time, but can edit existing solutions. Users can win multiple prizes, as we reward by submission, not user.",
        required: true,
        fields: questionnaireFields.multiple_solution_count,
      },
      {
        name: "Solution Privacy",
        description:
          "When solutions are marked as public, they might be publized to MindSumo users and used for marketing purposes. It is great for everybody if solutions are public.",
        required: true,
        fields: questionnaireFields.solutions_private,
      },
      {
        name: "Custom URL",
        required: false,
        fields: questionnaireFields.url_title,
      },
      {
        name: "Hide Entities from Word cloud",
        description:
          "Admin Only. Enter words separated by commas that you don't want to appear in the word cloud",
        required: false,
        fields: questionnaireFields.hide_entities,
      },
    ],
    "Challenge Client & Owner": [
      {
        name: "Rep and Email",
        required: true,
        fields: [
          questionnaireFields.rep_email,
          questionnaireFields.manager_email,
        ],
      },
      {
        name: "Select Company Team",
        required: true,
        fields: questionnaireFields.company_team_id,
      },
      {
        name: "Company Contact",
        required: true,
        fields: [
          questionnaireFields.contact_name,
          questionnaireFields.contact_email,
        ],
      },
    ],
    "Style Customization": [
      {
        name: "Custom banner color",
        description:
          "This color will replace the standard MindSumo header bar.",
        required: false,
        fields: [
          questionnaireFields.custom_banner_color_helper,
          questionnaireFields[
            "contest_layout_customization.custom_banner_color"
          ],
        ],
      },
      {
        name: "Custom banner logo",
        required: false,
        fields: [
          questionnaireFields[
            "contest_layout_customization.custom_banner_logo"
          ],
          questionnaireFields[
            "contest_layout_customization.remove_custom_banner_logo"
          ],
        ],
      },
      {
        name: "Custom banner title",
        description:
          "Enter your custom title to appear next to the logo in the banner.",
        required: false,
        fields:
          questionnaireFields[
            "contest_layout_customization.custom_banner_text"
          ],
      },
      {
        name: "Hide header links?",
        description:
          "Choose if the page should contain the standard MindSumo header links.",
        required: false,
        fields:
          questionnaireFields[
            "contest_layout_customization.hide_header_layout"
          ],
      },
      {
        name: "Hide footer links?",
        description:
          "Choose if the page should contain the standard MindSumo footer links (hide the upper part of the footer?).",
        required: false,
        fields:
          questionnaireFields[
            "contest_layout_customization.hide_footer_layout"
          ],
      },
      {
        name: "Hide demographics section on dashboard?",
        description:
          "Choose if the demographics should be hidden on the challenge dashboard.",
        required: false,
        fields:
          questionnaireFields[
            "contest_layout_customization.hide_demographics_section_on_dashboard"
          ],
      },
    ],
    "Extra Materials": [
      {
        name: "Extra Materials",
        required: false,
        fields: questionnaireFields.contestfiles,
      },
    ],
  },
};
